"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleDatePicker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var utils_1 = require("../utils");
var DatePickerBase_1 = require("../DatePickerBase");
var ThemeProvider_1 = require("../ThemeProvider");
var DatePickerValidationFunctions_1 = require("../DatePickerValidationFunctions");
exports.SingleDatePicker = function (props) {
    var defaultDate = props.startDate, _a = props.onApply, onApply = _a === void 0 ? noop_1.default : _a, _b = props.onCancel, onCancel = _b === void 0 ? noop_1.default : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.theme, theme = _d === void 0 ? 'default' : _d, _e = props.maxDate, maxDate = _e === void 0 ? DatePickerValidationFunctions_1.maximumDate : _e, _f = props.minDate, minDate = _f === void 0 ? DatePickerValidationFunctions_1.minimumDate : _f, _g = props.smartDate, smartDate = _g === void 0 ? false : _g;
    var dateNow = new Date();
    var _h = react_1.useState(defaultDate || dateNow), startDate = _h[0], setStartDate = _h[1];
    var _j = react_1.useState(false), hasDateChangeOccurred = _j[0], setHasDateChangeOccurred = _j[1];
    var _k = react_1.useState(utils_1.singleDateFormatter(defaultDate)), selectedValueStr = _k[0], setSelectedValueStr = _k[1];
    var onStartDateChange = function (value) {
        setHasDateChangeOccurred(true);
        setStartDate(value);
        setSelectedValueStr(utils_1.singleDateFormatter(value));
    };
    var handleApply = function () {
        onApply(startDate);
        setSelectedValueStr(utils_1.singleDateFormatter(startDate));
        setHasDateChangeOccurred(false);
    };
    var handleCancel = function () {
        setStartDate(defaultDate || dateNow);
        onCancel();
        setSelectedValueStr(utils_1.singleDateFormatter(defaultDate));
        setHasDateChangeOccurred(false);
    };
    return (react_1.default.createElement(ThemeProvider_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(DatePickerBase_1.DatePickerBase, { startDate: startDate, disabled: disabled, isRange: false, selectedValue: selectedValueStr, onStartDateChange: onStartDateChange, onApply: handleApply, onCancel: handleCancel, maxDate: maxDate, minDate: minDate, disableOnApply: !hasDateChangeOccurred, smartDate: smartDate })));
};
